<!-- File picker is registered declaratively as a pinned custom action via
     PageHeaderService.setPageActions(...). The Upload button is registered as
     a pinned PageActionButton that becomes enabled once a file is chosen. -->
<ng-template #filePickerAction>
  <ui-file-input
    [accept]="'application/pdf'"
    ariaLabel="Upload receipt PDF"
    variant="ghost"
    (fileSelected)="onFileSelected($event)">
  </ui-file-input>
</ng-template>

@if (receipts?.length) {
  <ui-list variant="bordered">
    @for (receipt of receipts; track receipt.id) {
      <ui-list-item [clickable]="true" [routerLink]="['/receipts/', receipt.id]">
        <div class="flex items-start justify-between gap-3 w-full">
          <div class="min-w-0 flex-1 shrink">
            <div class="font-medium text-base-content truncate">
              {{ receipt.retailer_name }} ({{ receipt.branch_name }})
            </div>
            <div class="text-sm text-base-content/60 mt-1">
              {{ receipt.purchase_date | date : "d. MMM H:mm" : 'UTC' }}
            </div>
          </div>

          <div class="shrink flex justify-content-sm-between gap-2">
            <span class="text-bg-secondary rounded-pill text-sm">{{ receipt?.owner?.nickname }}</span>
          </div>

          <div class="shrink-0 flex justify-content-sm-between gap-2">

            <div class="min-w-25">
              <ui-badge
                size="sm"
                [variant]="importStatusVariant(receipt.import_status)"
              >
                {{ receipt.import_status }}
              </ui-badge>
            </div>

            @if (receipt.has_file) {
              <fa-icon [icon]="faFileIndicator"></fa-icon>
            } @else {
              <fa-icon [icon]="faFileNotFound" [uiTooltip]="'No file available'" [tooltipPosition]="'left'"
                       class="text-base-content/30 text-error"></fa-icon>
            }

          </div>
        </div>
      </ui-list-item>
    }
  </ui-list>
} @else {
  <div class="text-center py-8 text-base-content/60">
    No receipts found
  </div>
}
